import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../nucleo/autorizacion/guardian.js';
import { rutaRaiz } from './raiz.js';

/**
 * Grupo del administrador. Se exige `usuario.administrar`, que en la matriz es
 * `no no no sí`: es la acción más restringida que existe y sirve de llave del grupo.
 */
export const rutaDireccion = createRoute({
  getParentRoute: () => rutaRaiz,
  id: '_direccion',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'usuario.administrar' }) }),
  // El proveedor de consultas llega a pedido: la raiz viaja en el fragmento de entrada y
  // la pantalla de ingreso no usa react-query. Ver rutas/consultas.tsx.
  component: lazyRouteComponent(() => import('./consultas.js'), 'ProveedorConsultas'),
});
